import React from 'react';
import { Translate } from 'react-redux-i18n';
import get from 'lodash.get';
import { ViewTable } from '../layouts/viewTable';
import ViewIconItem from '../layouts/viewIconItem';
import { pageTypesStrings } from '../../constants/pageTypes';

interface Props { entity: any; translationBase: string; }
export const PageEntityRelationships: React.FC<Props> = ({ entity, translationBase }) => {
  const team = get(entity,'team');
  const collection = get(entity,'collection');
  const campaign = get(entity,'campaign');
  const event = get(entity,'event');
  const organization = get(entity,'organization');
  const teamImage = get(team,'mainImageUrl') || get(campaign,'mainImageUrl');
  const collectionImage = get(collection,'mainImageUrl') || get(campaign,'mainImageUrl');
  const campaignImage = get(campaign,'mainImageUrl') || get(organization,'mainImageUrl');
  const eventImage = get(event,'mainImageUrl');
  const hasAny = team || collection || campaign || event || organization;
  if (!hasAny) return null;
  return (
    <div className="page-entity-relationships">
      <ViewTable title={<Translate value={`${translationBase}.page-information.title`} />}>
        {team && <ViewIconItem type={pageTypesStrings.TEAM} data={team} imageUrl={teamImage} />}
        {collection && <ViewIconItem type={pageTypesStrings.COLLECTION} data={collection} imageUrl={collectionImage} />}
        {campaign && <ViewIconItem type={pageTypesStrings.CAMPAIGN} data={campaign} imageUrl={campaignImage} />}
        {event && <ViewIconItem type={pageTypesStrings.EVENT} data={event} imageUrl={eventImage} hideId />}
  {/* Organization display skipped (no pageTypesStrings.ORGANIZATION) */}
      </ViewTable>
    </div>
  );
};
export default PageEntityRelationships;
